export default function hasPermission({user, requiredAuthGroup}) {
  var userAuthGroup = _.get(user, 'authGroup', 'anyone');

  var authGroupNumberMap = {
    anyone: 10,
    user: 20,
    trade: 25,
    employee: 30,
    admin: 40
  };

  var authGroupNumbers = {
    required: authGroupNumberMap[requiredAuthGroup] || 1000,
    user: authGroupNumberMap[userAuthGroup] || 10, //if invalid authGroup effectivly anyone
  };

  //HACK to avoid making a `trade` authGroup - proper solution is to do that,
  //but don't want existing apps that don't handle 'trade' to break
  if (_.get(user, 'isTrade') && authGroupNumbers.user < 25) authGroupNumbers.user = 25;

  return authGroupNumbers.required <= authGroupNumbers.user;
}

//TODO test
